import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImageCropperComponent } from 'ngx-image-cropper';

/**
 * Image cropper component
 */
@Component({
  selector: 'app-photo-cropper',
  standalone: true,
  imports: [ImageCropperComponent],
  templateUrl: './photo-cropper.component.html',
  styleUrls: ['./photo-cropper.component.scss']
})
export class PhotoCropperComponent implements OnInit {
  @Input() imageData = "";
  @Output() onImageCrop = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  imageCropped(ev: any) {
    this.onImageCrop.emit(ev.base64);
  }
}
